import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { CardBody, Button } from 'reactstrap';
import { translate } from "react-translate";
import TablePracticeOrders from './TablePracticeOrders';
import Paginator from '../Common/Paginator';
import Search from '../Common/Search'
import Loading from "plugins/TS-lib-utils-public/components/Loading/LoadingGlobal";
import { actionGetOrdersList } from 'store/actions/practiceOrdersActions';
import { useHistory } from 'react-router-dom';

const PracticeOrdersList = (props) => {
    const dispatch = useDispatch();
    const { data, page, lastPage, limit } = useSelector(state => state.practiceOrdersReducer.orders);
    const [loading, setloading] = useState(false);
    const [loadingLocal, setloadingLocal] = useState(false);
    const [_page, setPage] = useState(0);
    const [_limit, setLimit] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [filter, setFilter] = useState(null);
    const history = useHistory();

    useEffect(() => {
        dispatch(actionGetOrdersList(_page, _limit));
    }, []);

    useEffect(() => {

        if (data) {
            setloading(false);
            setloadingLocal(false);
            setPage(page);
            setLimit(limit);
            setTotalPage(lastPage);
        }

    }, [dispatch, data]);

    //method called by paginator and search
    function changeDataSearch(page, filter = null) {
        //if the search type "" refresh all data
        setloadingLocal(true)
        if (filter == null) {
            setFilter(null);
            dispatch(actionGetOrdersList(page, _limit));
        } else {
            //we save search input text, therefore we will only paginate the search results
            setFilter(filter);
            dispatch(actionGetOrdersList(page, _limit, filter));
        }
    }

    const createOrder = (e) => {
        e.preventDefault();
        history.push(`/admin/practice-orders/form/`);
    }

    return (
        <div className='content user-manual'>
                <CardBody>
                    <div>
                        <Loading loading={loading} />
                        <Search placeholder={"search-text-logList"} callback={changeDataSearch} />

                         <Button
                            size="sm"
                            color="info"
                            onClick={(e) => { createOrder(e) }}
                            >
                            Add new order
                        </Button>
                        

                        <TablePracticeOrders data={data} loading={loadingLocal} page={page} callback={changeDataSearch} />
                        <Paginator totalPages={totalPage} currentPage={_page} pageSize={_limit} filter={filter} callback={changeDataSearch} />
                    </div>
                </CardBody>
        </div>
    );
};
export default translate("practice-orders")(PracticeOrdersList);